import SEO from "@/components/SEO";
import { Award, Compass, Users, ShieldCheck } from "lucide-react";

export default function About() {
  return (
    <>
      <SEO title="About — Tech Alpha SSL" description="Senior engineers building the web's most trusted SSL, security, and hosting services." canonical="https://techalphassl.com/about" />
      <section className="pt-20 pb-16">
        <div className="container-page max-w-4xl">
          <span className="eyebrow">About Tech Alpha SSL</span>
          <h1 className="mt-4 text-4xl md:text-6xl font-semibold tracking-tighter">
            Built by security engineers.<br/>Trusted by modern businesses.
          </h1>
          <p className="mt-6 text-lg text-muted-foreground leading-relaxed">
            Tech Alpha SSL was founded on a simple belief: the web should be secure by default.
            We work exclusively with businesses that value uptime, encryption, and clean
            engineering — no shortcuts, no fluff, no ambiguity.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="container-page grid gap-6 md:grid-cols-4">
          {[
            { icon: ShieldCheck, title: "Security first", body: "Every decision is filtered through a security lens — from architecture to deployment." },
            { icon: Compass, title: "Clear roadmaps", body: "You always know what's happening, when it ships, and what's next." },
            { icon: Award, title: "Senior engineers", body: "The engineer who scopes your work is the engineer who ships it." },
            { icon: Users, title: "Long-term partners", body: "We stay after launch — monitoring, patching, and improving your posture over time." },
          ].map((v, i) => (
            <div key={i} className="card-elevated p-6">
              <v.icon className="h-6 w-6 text-[#1565FF] dark:text-[#4FC3F7]" />
              <h3 className="mt-4 text-base font-semibold tracking-tight">{v.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{v.body}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
